<template src="./template.html"></template>

<script>
export default {
  name: 'SubscriptionEditViewSection',
  props: {
    data: Object,
    methods: Object,
  },
}
</script>
